import { render, staticRenderFns } from "./VendorMappings.vue?vue&type=template&id=37c0cc6a"
import script from "./VendorMappings.vue?vue&type=script&lang=ts"
export * from "./VendorMappings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports